import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Partners() {
  const imageLinks = [
    "https://kulwebtech.com/wp-content/uploads/2022/09/rectron.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/kaspersky.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/microsoft-certified.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/Scoop.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/sonicwall-.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/tarsus-Tech-group.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/dell-Rp.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/liquid-IT.png",
    "https://kulwebtech.com/wp-content/uploads/2022/09/Scoop.png",
  ];

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  return (
    <div style={{ marginTop: "8rem " }} className="">
      <h1
        style={{
          textAlign: "center",
          color: "#203B54",
          fontWeight: "500",
          marginBottom: "0",
        }}
        className="hero-text "
      >
        Our Partners Trust Us
      </h1>
      <Slider {...settings}>
        {imageLinks.map((link, index) => (
          <div key={index} style={{ width: "5rem" }}>
            {" "}
            {/* Increase width */}
            <img
              src={link}
              alt={`Partner ${index}`}
              style={{ width: "100%" }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Partners;
